import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { getAccountManagerTemplate, ICandidate, ITemplateResponse, IJob } from 'wisestep-api';

import BulkEmail from '../../../components/BulkEmail';
import { SubmissionType } from '../../../features/conversationWidget/types/SubmissionTypes';
import { handleSelectedCandidatesLimit } from '../../../features/jobsCrm/components/helper/SendSmsEmailFuntionality';
import ErrorLogger from '../../../providers/ErrorLogger';

interface IEmailPopUpProps {
  candidate: ICandidate;
  job: IJob;
  openEmail: boolean;
  onClose: () => void;
  mailBody?: string;
  fromSubmissions?: boolean;
  submissionType?: SubmissionType | null;
}

const EmailPopUp = ({
  candidate,
  job,
  openEmail,
  onClose,
  mailBody,
  fromSubmissions,
  submissionType,
}: IEmailPopUpProps) => {
  const [template, setTemplate] = useState<ITemplateResponse>();

  useEffect(() => {
    const fetchTemplate = async () => {
      if (!job) return;
      try {
        const response = await getAccountManagerTemplate(
          job.submissionFormTemplete ?? '',
          job.workspaceId ?? ''
        );
        setTemplate(response.data);
      } catch (error) {
        console.error('Error fetching template:', error);
      }
    };
    fetchTemplate();
  }, [job]);

  const handleEmailDrawerClose = () => {
    onClose();
    handleSelectedCandidatesLimit(candidate);
  };

  if (!openEmail && !template) return null;

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
      <BulkEmail
        open={openEmail}
        handleClose={handleEmailDrawerClose}
        candidates={!candidate.isInDnc ? [candidate] : []}
        drawer
        recruiterEmail=""
        toEmailList={[job?.accountManagerEmail ?? '']}
        defaultJob={job}
        AMTemplate={template}
        submissionMailBody={mailBody}
        fromSubmissions={fromSubmissions}
        isSubmitExternal={submissionType === SubmissionType.EXTERNAL}
      />
    </ErrorBoundary>
  );
};

export default EmailPopUp;
